/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".icon-question").popover({
    trigger: "hover",
    placement: "top",
    html: true,
    content: function () {
      return $("#" + $(this).attr("id") + "-answer").html();
    },
  });
});
